import { render } from "./WorkContainer.vue?vue&type=template&id=f46a8204&scoped=true&lang=true"
import script from "./WorkContainer.vue?vue&type=script&lang=js"
export * from "./WorkContainer.vue?vue&type=script&lang=js"

import "./WorkContainer.vue?vue&type=style&index=0&id=f46a8204&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f46a8204"]])

export default __exports__